




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ZoomedImageComponent extends Vue {
  @Prop()
  public imageUri: string;

  public onfocus() {
    console.log('onfocus');
  }

  public mounted() {
    this.$nextTick(() => {
      (this.$refs.zoomedImage as HTMLAnchorElement).focus();
    });
  }

  public show: boolean = true;

  public closing: boolean = false;

  public closeZoomedImage(): void {
    const self = this;
    this.closing = true;

    setTimeout(() => {
      self.closing = false;
      self.show = false;
    }, 500);
  }
}
